export default __webpack_public_path__ + "static/media/open.b2eb1f82.svg";